import { axios } from './api';
import { getHttp } from './axios';


export function getMarks() {
    return axios.get('/audiogram/markers');
}

export function getAudiogramHistory() {
    return axios.get('/audiogram/history');
}
export function getReugHistory() {
    return axios.get('/reug/history');
}
export function getRecdHistory() {
    return axios.get('/recd/history');
}

export function getCurrentAudiogram(params = { side: "both" }) {
    return axios.get('/audiogram?side=both', { params });
}
export function getCurrentRecd(params = { side: "both" }) {
    return axios.get('/recd?side=both', { params });
}
export function getCurrentReug(params = { side: "both" }) {
    return axios.get('/reug?side=both', { params });
}

export function saveAudiogram(data) {
    return axios.post('/audiogram?side=both', data);
}
export function addAudiogramHistory(data) {
    return axios.post('/audiogram/history', data);
}
export function deleteAudiogramHistory(id) {
    return axios.delete('/audiogram?id=' + id);
}

export function saveRecd(data) {
    return axios.post('/recd?side=both', data);
}
export function addRecdHistory(data) {
    return axios.post('/recd/history', data);
}
export function deleteRecdHistory(id) {
    return axios.delete('/recd?id=' + id);
}

export function saveReug(data) {
    return axios.post('/reug?side=both', data);
}
export function addReugHistory(data) {
    return axios.post('/reug/history', data);
}
export function deleteReugHistory(id) {
    return axios.delete('/reug?id=' + id);
}

export function getAudiogramTransducers() {
    return axios.get('/audiogram/transducers');
}

export function getReugDefault() {
    return getHttp("/reug/default");
}


export function newSession(id) {
    return axios.post(`/patientManagement/session?patientId=${id}`);
}
export function saveSession() {
    return axios.post(`/fitting/session`);
}
export function deleteSession(patientId, sessionId) {
    return axios.delete(`/patientManagement/session?patientId=${patientId}&sessionId=${sessionId}`);
}